import React, { useState } from 'react';
import { experiences } from '../data/experiences';
import { SectionHeading } from './ui/SectionHeading';
import { Card } from './ui/Card';
import { Tag } from './ui/Tag';
import { Reveal } from '../lib/motion';
import { Icon } from '../lib/Icon';

function ExperienceCard({ exp }) {
  const [open, setOpen] = useState(false);
  return (
    <Card padding="26px">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', flexWrap: 'wrap', gap: 8 }}>
        <h3 style={{ fontSize: 'var(--text-h3)', margin: 0 }}>{exp.company}</h3>
        <span style={{ fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--text-muted)' }}>{exp.period}</span>
      </div>
      <div style={{ color: 'var(--accent)', fontWeight: 600, fontSize: 15, marginTop: 4 }}>{exp.role}</div>
      <p style={{ color: 'var(--text-secondary)', fontSize: 15, lineHeight: 1.65, margin: '14px 0 14px' }}>
        {exp.summary || exp.description}
      </p>
      {exp.summary && exp.description && (
        <>
          <div style={{
            display: 'grid',
            gridTemplateRows: open ? '1fr' : '0fr',
            transition: 'grid-template-rows var(--dur-slow) var(--ease-out)',
          }}>
            <div style={{ overflow: 'hidden' }}>
              <p style={{ color: 'var(--text-secondary)', fontSize: 14.5, lineHeight: 1.7, margin: '0 0 16px', whiteSpace: 'pre-line' }}>
                {exp.description}
              </p>
            </div>
          </div>
          <button
            onClick={() => setOpen((v) => !v)}
            data-cursor
            style={{
              display: 'inline-flex', alignItems: 'center', gap: 6, marginBottom: 16,
              background: 'transparent', border: 'none', cursor: 'pointer', padding: 0,
              fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--accent)',
              letterSpacing: '0.04em', transition: 'opacity var(--dur-fast) var(--ease-out)',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.opacity = '0.7'; }}
            onMouseLeave={(e) => { e.currentTarget.style.opacity = '1'; }}>
            {open ? 'Ver menos' : 'Ver detalhes'}
            <span style={{ display: 'inline-flex', transform: open ? 'rotate(-45deg)' : 'rotate(0)', transition: 'transform var(--dur-base) var(--ease-out)' }}>
              <Icon name="arrow-down-right" size={13} />
            </span>
          </button>
        </>
      )}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        {exp.tech.map((t) => <Tag key={t} size="sm" variant="muted">{t}</Tag>)}
      </div>
    </Card>
  );
}

export default function Experience() {
  return (
    <section id="experiencia" style={{ padding: 'var(--section-pad-y) clamp(20px,5vw,56px)', background: 'var(--bg-recessed)', borderTop: '1px solid var(--border-subtle)', borderBottom: '1px solid var(--border-subtle)' }}>
      <div style={{ maxWidth: 'var(--container-wide)', margin: '0 auto' }}>
        <Reveal><SectionHeading index="02" eyebrow="Experiência" title="Onde já construí" /></Reveal>
        <div style={{ position: 'relative', marginTop: 56, paddingLeft: 'clamp(20px,4vw,40px)' }}>
          <div aria-hidden="true" style={{ position: 'absolute', left: 6, top: 8, bottom: 8, width: 2, background: 'linear-gradient(180deg, var(--accent), var(--yellow-a16) 70%, transparent)' }} />
          <div style={{ display: 'flex', flexDirection: 'column', gap: 22 }}>
            {experiences.map((exp, i) => (
              <Reveal key={i} delay={i * 70}>
                <div style={{ position: 'relative' }}>
                  <span aria-hidden="true" style={{ position: 'absolute', left: 'calc(-1 * clamp(20px,4vw,40px) + 1px)', top: 26, width: 12, height: 12, borderRadius: '50%', background: i === 0 ? 'var(--accent)' : 'var(--ink-700)', border: '2px solid var(--ink-950)', boxShadow: i === 0 ? '0 0 0 4px var(--yellow-a16)' : 'none', transform: 'translateX(-5px)' }} />
                  <ExperienceCard exp={exp} />
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
